/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface ICaseContentItem {
  id?: string | number;
  title?: string;
  text?: string;
  link?: string;
}

export interface ICaseTabsItem {
  caseTitle?: string;
  l5?: string;
  l6?: string;
  caseContent?: ICaseContentItem[];
}

export interface ICaseTabsContentProps {
  item: ICaseTabsItem;
}

const stripTagSuffix = (label?: string) =>
  label?.replace(/[：:]\s*$/, '') ?? '';

const CaseTabsContent: React.FunctionComponent<ICaseTabsContentProps> = ({
  item,
}) => {
  if (!item) return null;

  const tagLabel = stripTagSuffix(item.l5);

  return (
    <div className="case-tabs-content">
      <div className="case-tabs-content-header">
        {tagLabel && <span className="case-tabs-content-tag">{tagLabel}</span>}
        {item.l6 && <h3 className="case-tabs-content-title">{item.l6}</h3>}
      </div>
      {item.caseTitle && (
        <p className="case-tabs-content-intro">{item.caseTitle}</p>
      )}
      <div className="case-tabs-content-cards">
        {item.caseContent?.map((contentItem, index) => (
          <div key={contentItem.id ?? index} className="case-tabs-content-card">
            <div className="case-tabs-content-card-index">
              {contentItem.title ??
                String(contentItem.id ?? index + 1).padStart(2, '0')}
            </div>
            <div className="case-tabs-content-card-divider" />
            {contentItem.link ? (
              <p
                className="case-tabs-content-card-text"
                dangerouslySetInnerHTML={{ __html: contentItem.text ?? '' }}
              />
            ) : (
              <p className="case-tabs-content-card-text">{contentItem.text}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(CaseTabsContent);
